export function tagAbbreviation(tag) {
  const explicit = tag.kuerzel || tag.abkuerzung;
  if (explicit) return explicit;
  const name = (tag.name || '').replace(/^Kein(e|en|er|es)?\s+/i, '').trim();
  if (name.length <= 6) return name.toLocaleUpperCase('de');
  const words = name.split(/[\s-]+/).filter(Boolean);
  return (words.length > 1 ? words.map(word => word[0]).join('').slice(0, 6) : name.slice(0, 4)).toLocaleUpperCase('de');
}
